import { Drawer } from '@loadsmart/miranda-react'

import { StepContent } from './StepContent'

export type OpenDockAppointmentScheduledDrawerProps = {
  isOpen: boolean
  onClose: () => void
}

export function OpenDockAppointmentScheduledDrawer({
  isOpen,
  onClose,
}: OpenDockAppointmentScheduledDrawerProps) {
  return (
    <Drawer open={isOpen} onClose={onClose}>
      <StepContent />
    </Drawer>
  )
}
